import { Box, Drawer } from '@mui/material';
import styled from 'styled-components';

export const resizePanelStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#fff'
};

export const Container = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100vw',
  height: '100vh'
});

export const Preview = styled(Box)({
  display: 'flex',
  height: '100%',
  minHeight: '100vh'
});

export const SidebarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.grey[300]}`
}));

export const SidebarSection = styled(Box)(({ theme }) => ({
  height: 'auto',
  width: '100%',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  padding: '1.25rem',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap'
}));

export const SidebarForm = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  padding: '1.25rem',
  borderBottom: `1px solid ${theme.palette.grey[300]}`
}));

export const SidebarLinkLabel = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: '0.875rem'
}));

/* Make sure the preview drawer sits below the global nav header */
export const PreviewDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    top: 3.75rem;
  }
`;
